import useAuth from "minimals-template/components/@hooks/useAuth"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { useServerEventsLongPolling } from "lib/graphql/use-server-events-long-polling"

export function ServerEvents({ children }) {
    const auth = useAuth()
    const { loading } = useServerEventsLongPolling()
    return loading || auth.isLoggingIn ? <LoadingScreen description="Connecting to server" /> : children
}
